import { render, staticRenderFns } from "./SolePropB.vue?vue&type=template&id=78fce8c9&scoped=true"
import script from "./SolePropB.vue?vue&type=script&lang=js"
export * from "./SolePropB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fce8c9",
  null
  
)

export default component.exports